/** Labels PT-BR para status de job (web MVP). */
export const JOB_STATUS_LABELS = {
  open: 'Aberto',
  searching: 'Buscando videomaker',
  waiting_videomaker: 'Aguardando videomaker',
  scheduled: 'Agendado',
  in_progress: 'Em andamento',
  waiting_delivery: 'Aguardando entrega',
  delivery_processing: 'Processando mídias',
  revision_requested: 'Revisão solicitada',
  waiting_approval: 'Aguardando aprovação',
  awaiting_client_confirmation: 'Aguardando confirmação',
  approved: 'Aprovado',
  completed: 'Concluído',
  cancelled: 'Cancelado',
  rejected: 'Rejeitado',
};

export function getJobStatusLabel(status) {
  return JOB_STATUS_LABELS[status] || status || '—';
}

export const CLIENT_ACTIVE_STATUSES = [
  'waiting_delivery',
  'delivery_processing',
  'revision_requested',
  'waiting_approval',
  'awaiting_client_confirmation',
  'in_progress',
];

export const CLIENT_DONE_STATUSES = ['completed', 'approved'];

export const VM_UPLOAD_STATUSES = [
  'waiting_delivery',
  'revision_requested',
  'delivery_processing',
];

export function formatCurrency(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return 'R$ 0,00';
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}
